import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Textarea } from "../../ui/textarea";
import { Button } from "../../ui/button";
import { Plus } from "lucide-react";

export const PackageForm = ({ form, setForm, editingId, category, categoryLabel, saving, onSubmit, onCancel }) => (
  <div className="border-t pt-4 space-y-3">
    <p className="text-sm font-medium">{editingId ? "Editar paquete" : `Nuevo paquete en "${categoryLabel}"`}</p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <div>
        <Label>Nombre del paquete</Label>
        <Input data-testid="admin-package-form-name" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} placeholder="Ej. Paquete Premium" />
      </div>
      {category !== "invitacion_digital" && (
        <div>
          <Label>Horas de cobertura</Label>
          <Input data-testid="admin-package-form-hours" type="number" value={form.hours} onChange={(e) => setForm((f) => ({ ...f, hours: e.target.value }))} />
        </div>
      )}
      {category !== "cabina_fotos" && category !== "invitacion_digital" && category !== "podcast_boda" && (
        <div>
          <Label>Número de fotos entregadas</Label>
          <Input data-testid="admin-package-form-photos-count" type="number" value={form.photos_count} onChange={(e) => setForm((f) => ({ ...f, photos_count: e.target.value }))} placeholder="Ej. 350" />
        </div>
      )}
      {(category === "content_creator" || category === "foto_video") && (
        <div>
          <Label>Número de videos entregados</Label>
          <Input data-testid="admin-package-form-videos-count" type="number" value={form.videos_count} onChange={(e) => setForm((f) => ({ ...f, videos_count: e.target.value }))} placeholder="Ej. 5" />
        </div>
      )}
      {category === "podcast_boda" && (
        <>
          <div>
            <Label>Número de clips entregados</Label>
            <Input data-testid="admin-package-form-clips-count" type="number" value={form.clips_count} onChange={(e) => setForm((f) => ({ ...f, clips_count: e.target.value }))} placeholder="Ej. 10" />
          </div>
          <div>
            <Label>Número de Video Master entregado</Label>
            <Input data-testid="admin-package-form-video-master-count" type="number" value={form.video_master_count} onChange={(e) => setForm((f) => ({ ...f, video_master_count: e.target.value }))} placeholder="Ej. 1" />
          </div>
        </>
      )}
      <div className="md:col-span-2">
        <Label>Descripción (qué incluye)</Label>
        <Textarea data-testid="admin-package-form-description" value={form.description} onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))} />
      </div>
      <div>
        <Label>Precio (MXN)</Label>
        <Input data-testid="admin-package-form-price" type="number" value={form.price} onChange={(e) => setForm((f) => ({ ...f, price: e.target.value }))} />
      </div>
    </div>
    <div className="flex gap-2">
      <Button data-testid="admin-package-submit-button" onClick={onSubmit} disabled={saving}>
        <Plus size={16} className="mr-1" /> {editingId ? "Guardar cambios" : "Crear paquete"}
      </Button>
      {editingId && (
        <Button data-testid="admin-package-cancel-edit" variant="outline" onClick={onCancel}>Cancelar</Button>
      )}
    </div>
  </div>
);
